import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export const useNavigationExplorer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [params, setParams] = useSearchParams();
    const open =
        location.pathname === "/navigation" ||
        params.get("navigation") === "all";
    const [areaId, setAreaId] = useState<string | null>(null);
    const previous = useRef(open);
    const origin = useRef({ pathname: location.pathname, scroll: 0 });
    const show = (selectedAreaId?: string): void => {
        setAreaId(selectedAreaId || null);
        if (selectedAreaId) {
            if (params.get("navigation") !== "all") {
                const next = new URLSearchParams(params);
                next.set("navigation", "all");
                setParams(next, { state: { workspaceExplorer: true } });
            }
            return;
        }
        if (location.pathname === "/navigation") {
            return;
        }
        origin.current = {
            pathname: location.pathname,
            scroll: window.scrollY,
        };
        navigate("/navigation", { state: { workspaceExplorer: true } });
    };
    const close = (): void => {
        setAreaId(null);
        const state = location.state as { workspaceExplorer?: boolean } | null;
        if (state?.workspaceExplorer) {
            navigate(-1);
            return;
        }
        if (location.pathname === "/navigation") {
            navigate(origin.current.pathname, { replace: true });
            return;
        }
        const next = new URLSearchParams(params);
        next.delete("navigation");
        setParams(next, { replace: true });
    };
    useEffect(() => {
        let frame = 0;
        if (open) {
            window.scrollTo({ top: 0 });
        }
        if (previous.current && !open) {
            frame = requestAnimationFrame(() => {
                document
                    .getElementById("workspace-content")
                    ?.focus({ preventScroll: true });
                window.scrollTo({
                    top:
                        origin.current.pathname === location.pathname
                            ? origin.current.scroll
                            : 0,
                });
            });
        }
        previous.current = open;
        return () => cancelAnimationFrame(frame);
    }, [open, location.pathname]);
    return { open, areaId, show, close };
};
